// hooks

// libraries
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import type { DealState, StateTree } from '@makemydeal/dr-dash-types';
import * as dealEffectiveSelectors from '@makemydeal/dr-dash-store/selectors/dealEffectiveSelectors';

// consts
import * as constants from '../../constants';

// components
import DealSummaryItem from '../common/DealSummaryItem';

// hooks
import { useDealSummary } from '../../common/DealSummaryProvider';

// styles
import { detailedViewValueStyles } from '../utils/styles';
import { useTrackedSelector } from '../../telemetry/useTrackedSelector';

const BalloonPayment = ({ deal }: DealState) => {
    const balloonAmount = useTrackedSelector(
        (state: StateTree) => dealEffectiveSelectors.selectEffectiveBalloonAmount(state, deal),
        { component: 'BalloonPayment', field: 'effectiveBalloonAmount' }
    );
    const { showDetailedView } = useDealSummary();

    return (
        <DealSummaryItem
            label={constants.BALLOON_PAYMENT}
            value={formatDollarsAndCents(balloonAmount || 0)}
            valueStyles={showDetailedView ? detailedViewValueStyles : {}}
        />
    );
};

export default BalloonPayment;
